import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./SearchResults.css";

interface Person {
  firstName: string;
  lastName: string;
  title: string;
}

const people: Person[] = [
  {
    firstName: "Oludurotimi",
    lastName: "Adetunji",
    title: "Associate Dean for Undergraduate Research and Inclusive Science",
  },
  {
    firstName: "Martha",
    lastName: "Alexander",
    title:
      "Associate Vice President for Institutional Equity, Accessibility and Compliance",
  },
  {
    firstName: "Samantha",
    lastName: "Andersen",
    title: "Assistant Director, Alumni Belonging Programs",
  },
  {
    firstName: "Richard",
    lastName: "Cancio",
    title: "Education and Training Manager, Diversity, Equity, and Inclusion",
  },
  {
    firstName: "Kelley",
    lastName: "Chase",
    title: "Director, Alumni Belonging Programs",
  },
  {
    firstName: "Alyssia",
    lastName: "Coates",
    title: "Senior Director of Development, Inclusive Philanthropic Engagement",
  },
  {
    firstName: "Madyson",
    lastName: "Crawford",
    title: "Assistant Director, Sarah Doyle Center for Women and Gender",
  },
  {
    firstName: "Nancy",
    lastName: "DeSousa",
    title: "Director of Institutional Equity and Diversity",
  },
  {
    firstName: "Marielena",
    lastName: "Del Pozo",
    title: "Program Manager, Diversity, Equity, and Inclusion",
  },
  {
    firstName: "Joseph",
    lastName: "Diaz",
    title:
      "Associate Dean for Diversity and Multicultural Affairs, Associate Professor of Medical Science, Associate Professor of Medicine",
  },
  {
    firstName: "Jennifer",
    lastName: "Eliezer",
    title: "Associate Director of Learning Initiatives & Inclusive Community",
  },
  {
    firstName: "Bianca",
    lastName: "Figueroa-Santana",
    title: "Institutional Equity Investigator",
  },
  {
    firstName: "Eldridge",
    lastName: "Gilbert",
    title: "Leadership Coach, Health Equity Scholars Program",
  },
  {
    firstName: "Tristan",
    lastName: "Glenn",
    title:
      "Assistant Vice President of Inclusion, Campus Culture, and Engagement",
  },
  {
    firstName: "Ashley",
    lastName: "Greene",
    title:
      "Director of Community Partnership/Assistant Dean of the College for Community Engagement",
  },
  {
    firstName: "Matthew",
    lastName: "Guterl",
    title:
      "L. Herbert Ballou University Professor of Africana Studies and American Studies, Vice President for Diversity and Inclusion",
  },
  {
    firstName: "Maija",
    lastName: "Hallsmith",
    title: "Assistant Director of Graduate Academic Diversity",
  },
  {
    firstName: "Vincent",
    lastName: "Harris",
    title: "Associate Dean and Director of Brown Center for Students of Color",
  },
  {
    firstName: "Andrew",
    lastName: "Heald",
    title: "Director, Global Brown Center for International Students",
  },
  {
    firstName: "Francisco",
    lastName: "Hernandez",
    title: "Senior Director, Diversity, Equity and Inclusion",
  },
  {
    firstName: "Silvina",
    lastName: "Hernandez Duran",
    title: "Assistant Director of Alumni Belonging",
  },
  {
    firstName: "Nicole",
    lastName: "Jeung",
    title: "Program Coordinator, Brown Center for Students of Color",
  },
  {
    firstName: "Soljane",
    lastName: "Martinez",
    title: "Director of Library Diversity, Equity, and Inclusion",
  },
  {
    firstName: "Keri",
    lastName: "McDonough",
    title:
      "Assistant Director for the LGBTQ Center and Graduate Student Engagement",
  },
  {
    firstName: "Victoria",
    lastName: "Mealer-Flowers",
    title:
      "Student-Athlete Development Senior Manager, Community Engagement and DEI Programs",
  },
  {
    firstName: "Yolanda",
    lastName: "Meikle",
    title: "Diversity and Inclusion Development Coordinator",
  },
  {
    firstName: "Eden",
    lastName: "Morrison",
    title: "Lead Teaching Fellow, National Education Equity Lab",
  },
  {
    firstName: "Abbey",
    lastName: "Nicholson",
    title: "Program Associate, Alumni Belonging",
  },
  {
    firstName: "Caitlin",
    lastName: "O'Neill",
    title: "Director, LGBTQ Center",
  },
  {
    firstName: "Bianca",
    lastName: "Pallo",
    title: "Black History at Brown University Project Archivist",
  },
  {
    firstName: "Juana",
    lastName: "Parillon",
    title:
      "Assistant Vice President of Institutional Equity and Diversity and Chief of Staff",
  },
  {
    firstName: "Patricia",
    lastName: "Poitevien",
    title:
      "Senior Associate Dean for Diversity, Equity and Inclusion, Associate Professor of Pediatrics",
  },
  {
    firstName: "Anne",
    lastName: "Ponte",
    title: "Program Coordinator, Brown Center for Students of Color",
  },
  {
    firstName: "Jai-Me",
    lastName: "Potter-Rutledge",
    title: "Assistant Dean of Diversity, Equity and Inclusion",
  },
  {
    firstName: "Shankar",
    lastName: "Prasad",
    title: "Instructor, National Education Equity Lab",
  },
  {
    firstName: "Steven",
    lastName: "Radilla",
    title: "Diversity Initiatives Program Coordinator",
  },
  {
    firstName: "Arden",
    lastName: "Reynolds",
    title: "ENGL 0511C Lead Teaching Fellow, National Education Equity Lab",
  },
  {
    firstName: "Natalia",
    lastName: "Roman Alicea",
    title: "Assistant Director of Alumni Belonging",
  },
  {
    firstName: "Megan",
    lastName: "Russell",
    title: "Associate Dean of Diversity, Equity and Inclusion",
  },
  {
    firstName: "Felicia",
    lastName: "Salinas-Moniz",
    title: "Director, Sarah Doyle Center for Women and Gender",
  },
  {
    firstName: "Ajee",
    lastName: "Schaeffer",
    title: "Assistant Director for the Brown Center for Students of Color",
  },
  {
    firstName: "Endawnis",
    lastName: "Spears",
    title: "Practitioner in Residence for Tribal Engagement",
  },
  {
    firstName: "Sarah",
    lastName: "Stetson",
    title: "Equity & Diversity Data Analyst",
  },
  {
    firstName: "Rosenny",
    lastName: "Taveras",
    title: "Director, Health Equity Scholars Program",
  },
  {
    firstName: "Ruth",
    lastName: "Torres",
    title:
      "Tribal Community Member in Residence and Student Engagement Specialist",
  },
  {
    firstName: "Loc",
    lastName: "Truong",
    title:
      "Associate Vice President of Campus Life for Inclusive Community and Belonging",
  },
  {
    firstName: "Andrew",
    lastName: "Vincent",
    title: "Assistant Director for the Brown Center for Students of Color",
  },
  {
    firstName: "Mary",
    lastName: "Ward",
    title: "Senior Director, Alumni Belonging",
  },
  {
    firstName: "Joi",
    lastName: "Whitehead",
    title:
      "Assistant Dean for Equity Initiatives and University K-12 Engagement",
  },
];

const SearchResults: React.FC = () => {
  return (
    <div className="search-results-wrapper">
      <div className="search-results-list">
        {people.map((person, index) => (
          <div
            key={index}
            className="search-result-box"
            style={{ "--rating-color": "#e74c3c" } as React.CSSProperties}
          >
            <div className="tag-badge" style={{ backgroundColor: "#e74c3c" }}>
              SUSPECT
            </div>
            <div className="profile-name">
              {person.firstName} {person.lastName}
            </div>
            <div className="profile-title">{person.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
